import { CONFIG } from '../config';
import { isDevelopment } from '../lib/isEnv';

export const USER_API_URL = isDevelopment()
  ? CONFIG.USER_API_URL
  : `${CONFIG.DISCOVERY_API_URL}/user-api`;
